import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { loadEventList, resetVEvent } from '../../features/event.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { Router } from '@angular/router';
import { EventService } from 'app/event/services/event.service';
import { ToastService } from 'app/toast/services/toast.service';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { SamModalService } from 'app/event/services/sam-modal.service';

let id = 1;

@Component({
  selector: 'app-actions-popover-event',
  templateUrl: './actions-popover-event.component.html',
  styleUrls: ['./actions-popover-event.component.scss']
})
export class ActionsPopoverEventComponent implements OnDestroy{

  @ViewChild('popover') popover: MdbPopoverDirective = null;
  
  @Input() event:any = null

  private _id = id++;
  get id() {
    return `ActionsPopoverEvent_${this._id}`;
  }

  public CAMPAIGN_TYPE = CAMPAIGN_TYPE;
  public isProduction = false;
  public takeUntilSubject: Subject<any> = new Subject();
  public modalRef: MdbModalRef<ConfirmModalComponent> | null = null;
  
  constructor(    
    private store: Store,
    private popoverService: PopoverService,
    private sharedService: SharedService,
    private router: Router,
    public eventService:EventService,
    private toastService: ToastService, 
    private modalService: MdbModalService,

  ) {
    this.isProduction = window['isProduction'];
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  onClickReportEvent(event, type) {
    switch(event.type) {
      case 0:
        this.router.navigateByUrl(`/event/in-person/${event.inPersonEventInfo.id}/report`)
        break;
      case 1:
        this.router.navigateByUrl(`/event/virtual/${event.virtualEventInfo.id}/report`)
        break;
      case 2:
        if(type === 0) {
          this.router.navigateByUrl(`/event/in-person/${event.hybridEventInfo.inPersonEvent.id}/report`)
        } else if (type === 1) {
          this.router.navigateByUrl(`/event/virtual/${event.hybridEventInfo.virtualEvent.id}/report`)
        }
    }
  }

  onClickUpgradeToHybrid(event) {
    const eventTypeText = event.type === 0 ? 'In-person' : 'Virtual'

    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: false,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: `This will upgrade ${eventTypeText} Event to Hybrid Event.`,
        onClose: (status)=>{
          this.modalRef.close();
          if(status){
            switch(event.type) {
              case 0:
                let paramsInp = {
                  eventId : event.inPersonEventInfo.id,
                  eventType: 0
                  }
                this.eventService.upgradeEvent(paramsInp).pipe(
                    takeUntil(this.takeUntilSubject)
                  ).subscribe((data)=>{
                    this.router.navigateByUrl(`/event/list`)
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: "smooth"
                    });
                    this.toastService.showSuccess(`In-person event ${event.inPersonEventInfo.name} was upgraded to Hybrid event`, {delay:2000});
                  })
                break;
              case 1:
                let paramsVir = {
                  eventId : event.virtualEventInfo.id,
                  eventType: 1
                  }
                this.eventService.upgradeEvent(paramsVir).pipe(
                  takeUntil(this.takeUntilSubject)
                ).subscribe((data)=>{
                  this.router.navigateByUrl(`/event/list`)
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                  });
                  this.toastService.showSuccess(`Virtual event ${event.virtualEventInfo.name} was upgraded to Hybrid event`, {delay:2000});
                })
                break;
            }
          }
        }
      }
    });
  }

  onClickCopyEvent(event) {
    const action =  DialogActions.openDialog({
      payload: {
        name: "copyEvent",
        options: {
          size: 'default',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState:{
          event,
          callback: (options) => {
            if(options){
              this.eventService.copyEvent(options,event.type)
              this.eventService.copyEvent(options,event.type).pipe(
                takeUntil(this.takeUntilSubject)
              ).subscribe((event)=>{
                if(event){
                  this.toastService.showSuccess(`New Event was created`, {delay:2000});
                  this.store.dispatch({
                    type: loadEventList.type,
                    payload: this.sharedService.token
                  });
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                  });
                }
              })
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  onClickResetData(event) {
    const resetDataAction = this.generateConfirmAction("confirmResetAuctionData", {
      event,
      text: "This action will reset all event data",
      callback: (result) => {
        if(result == false) {
          return false;
        }

        let id = null;
        switch(event.type) {
          case 1:
            id = event.virtualEventInfo.id;
            break;
          case 2:
            id = event.hybridEventInfo.virtualEvent.id;
            break;
        }
        this.store.dispatch({
          type: resetVEvent.type,
          payload: id
        });
      }
    });
    this.store.dispatch(resetDataAction);
  }

  generateConfirmAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState
      }
    });
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
